export enum UserRolesEnum {
    Ballance_Admin = 'Ballance_Admin',
    Ballance_Chat_History_QA = 'Ballance_Chat_History_QA',
    Ballance_Chat_History_Prod = 'Ballance_Chat_History_Prod',
    Ballance_Health_Dashboard_QA = 'Ballance_Health_Dashboard_QA',
    Ballance_Health_Dashboard_Prod = 'Ballance_Health_Dashboard_Prod',
    Ballance_Deep_Eval = 'Ballance_Deep_Eval',
}

export enum UserRolesConditionEnum {
    All = 'All',
    Any = 'Any',
}
